var _style, _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st3{fill:#ffcfb8}.st4{fill:#ffa77b}.st6{fill:#746887}.st7{fill:#f98770}")), /*#__PURE__*/React.createElement("path", {
    d: "M123.5 36.5h-62c-1.66 0-3 1.34-3 3v84c0 1.66 1.34 3 3 3h62c1.66 0 3-1.34 3-3v-84c0-1.66-1.34-3-3-3z",
    style: {
      fill: "#f6f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5 1.5h-99c-1.66 0-3 1.34-3 3v104c0 1.66 1.34 3 3 3h54v-72c0-1.66 1.34-3 3-3h45v-32c0-1.66-1.34-3-3-3z",
    style: {
      fill: "#e9eaeb"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m109.75 72.5-8.33 16.22a8.19 8.19 0 0 0-.92 3.79v33.99h18V92.41c0-1.26-.29-2.5-.83-3.63l-7.92-16.28z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m109.75 72.5-8.33 16.22a8.19 8.19 0 0 0-.92 3.79v.99h18v-1.09c0-1.26-.29-2.5-.83-3.63l-7.92-16.28z",
    style: {
      fill: "#ffbc99"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M123.5 36.5h-62c-1.66 0-3 1.34-3 3v16h68v-16c0-1.66-1.34-3-3-3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 74.5,
    cy: 70.5,
    r: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 74.5,
    cy: 90.5,
    r: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 74.5,
    cy: 111.5,
    r: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.5 1.5h-99c-1.66 0-3 1.34-3 3v11h105v-11c0-1.66-1.34-3-3-3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M91.5 27.5h-75a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h42v-16a3 3 0 0 1 3-3h33v-6a3 3 0 0 0-3-3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M111.099 71.844a1.502 1.502 0 0 0-1.333-.844 1.457 1.457 0 0 0-1.351.815l-8.326 16.211A9.753 9.753 0 0 0 99 92.51v.99a1.5 1.5 0 0 0 1.5 1.5h18a1.5 1.5 0 0 0 1.5-1.5v-1.09a10.01 10.01 0 0 0-.981-4.287l-7.92-16.279zM102.019 92a6.712 6.712 0 0 1 .735-2.595l6.959-13.551 6.603 13.572c.387.811.616 1.692.671 2.574h-14.968z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M111.099 71.844a1.502 1.502 0 0 0-1.333-.844 1.457 1.457 0 0 0-1.351.815l-8.326 16.211A9.753 9.753 0 0 0 99 92.51v33.99a1.5 1.5 0 0 0 1.5 1.5h18a1.5 1.5 0 0 0 1.5-1.5V92.41a10.01 10.01 0 0 0-.981-4.287l-7.92-16.279zM117 125h-15V92.51c0-1.084.259-2.155.754-3.105l6.959-13.551 6.603 13.572c.447.936.684 1.968.684 2.984V125z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M91.5 26h-75a4.505 4.505 0 0 0-4.5 4.5v22c0 2.481 2.019 4.5 4.5 4.5h42a1.5 1.5 0 0 0 1.5-1.5v-16c0-.827.673-1.5 1.5-1.5h33a1.5 1.5 0 0 0 1.5-1.5v-6c0-2.481-2.019-4.5-4.5-4.5zm1.5 9H61.5a4.505 4.505 0 0 0-4.5 4.5V54H16.5c-.827 0-1.5-.673-1.5-1.5v-22c0-.827.673-1.5 1.5-1.5h75c.827 0 1.5.673 1.5 1.5V35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M123.5 35h-62a4.505 4.505 0 0 0-4.5 4.5v16a1.5 1.5 0 0 0 1.5 1.5h68a1.5 1.5 0 0 0 1.5-1.5v-16c0-2.481-2.019-4.5-4.5-4.5zm1.5 19H60V39.5c0-.827.673-1.5 1.5-1.5h62c.827 0 1.5.673 1.5 1.5V54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M123.5 35h-62a4.505 4.505 0 0 0-4.5 4.5v84c0 2.481 2.019 4.5 4.5 4.5h62c2.481 0 4.5-2.019 4.5-4.5V95.983a1.5 1.5 0 1 0-3 0V123.5c0 .827-.673 1.5-1.5 1.5h-62c-.827 0-1.5-.673-1.5-1.5v-84c0-.827.673-1.5 1.5-1.5h62c.827 0 1.5.673 1.5 1.5v48.533a1.5 1.5 0 1 0 3 0V39.5c0-2.481-2.019-4.5-4.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.5 45h-3a1.5 1.5 0 1 0 0 3h3a1.5 1.5 0 1 0 0-3zM79.5 45h-3a1.5 1.5 0 1 0 0 3h3a1.5 1.5 0 1 0 0-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M74.5 63c-4.136 0-7.5 3.364-7.5 7.5s3.364 7.5 7.5 7.5 7.5-3.364 7.5-7.5-3.364-7.5-7.5-7.5zm0 12c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5 4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5zM74.5 83c-4.136 0-7.5 3.364-7.5 7.5s3.364 7.5 7.5 7.5 7.5-3.364 7.5-7.5-3.364-7.5-7.5-7.5zm0 12c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5 4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5zM74.5 104c-4.136 0-7.5 3.364-7.5 7.5s3.364 7.5 7.5 7.5 7.5-3.364 7.5-7.5-3.364-7.5-7.5-7.5zm0 12c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5 4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5zM103.5 0h-99A4.505 4.505 0 0 0 0 4.5v11A1.5 1.5 0 0 0 1.5 17h105a1.5 1.5 0 0 0 1.5-1.5v-11c0-2.481-2.019-4.5-4.5-4.5zm1.5 14H3V4.5C3 3.673 3.673 3 4.5 3h99c.827 0 1.5.673 1.5 1.5V14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M10.557 110H4.5c-.827 0-1.5-.673-1.5-1.5V31.25a1.5 1.5 0 1 0-3 0v77.25c0 2.481 2.019 4.5 4.5 4.5h6.057a1.5 1.5 0 1 0 0-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M103.5 0h-99A4.505 4.505 0 0 0 0 4.5v18.778a1.5 1.5 0 1 0 3 0V4.5C3 3.673 3.673 3 4.5 3h99c.827 0 1.5.673 1.5 1.5V35H61.5a4.505 4.505 0 0 0-4.5 4.5V110H18.202a1.5 1.5 0 1 0 0 3H58.5a1.5 1.5 0 0 0 1.5-1.5v-72c0-.827.673-1.5 1.5-1.5h45a1.5 1.5 0 0 0 1.5-1.5v-32c0-2.481-2.019-4.5-4.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M14.5 7h-3a1.5 1.5 0 1 0 0 3h3a1.5 1.5 0 1 0 0-3zM23.5 7h-3a1.5 1.5 0 1 0 0 3h3a1.5 1.5 0 1 0 0-3zM58.5 65h-45a1.5 1.5 0 1 0 0 3h45a1.5 1.5 0 1 0 0-3zM58.5 75h-45a1.5 1.5 0 1 0 0 3h45a1.5 1.5 0 1 0 0-3zM58.5 85h-45a1.5 1.5 0 1 0 0 3h45a1.5 1.5 0 1 0 0-3zM34.5 95h-21a1.5 1.5 0 1 0 0 3h21a1.5 1.5 0 1 0 0-3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUi);
export default __webpack_public_path__ + "static/media/ui.ea1dca4ae0f6b644ccef2598e4cf0a6d.svg";
export { ForwardRef as ReactComponent };